import { memo, Profiler, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button, Group } from '@mantine/core';
import { ChevronLeft } from 'lucide-react';
import { useHasPermission } from '../../../providers/AuthProvider';
import { useAdminUser } from '../../../hooks/useAdminUser';
import { UserInfoSection } from '../../../admin/components/UserInfoSection';
import { UserCustomAudiosTab } from '../../../admin/components/UserCustomAudiosTab';

const AdminUserAudios = memo(() => {
  const hasManageProducts = useHasPermission('manage_products');
  const { id } = useParams<{ id: string }>();
  const adminUserData = useAdminUser();

  const onRenderCallback = useCallback(
    (profilerId: string, phase: string, actualDuration: number) => {
      if (actualDuration > 8) {
        console.warn(
          `🐌 Slow render detected in ${profilerId}: ${phase} took ${actualDuration}ms`
        );
      }
    },
    []
  );

  if (!hasManageProducts) {
    return <div>Non hai i permessi per gestire gli audio personalizzati</div>;
  }

  if (!id) {
    return <div>Utente non trovato</div>;
  }

  return (
    <Profiler id='AdminUserAudios' onRender={onRenderCallback}>
      <Group mb='md'>
        <Button
          variant='subtle'
          leftSection={<ChevronLeft size={16} />}
          component={Link}
          to={`/admin/users/${id}`}
        >
          Torna al Profilo Utente
        </Button>
      </Group>

      <UserInfoSection
        userInfo={adminUserData.userInfo}
        loadingUserInfo={adminUserData.loadingUserInfo}
      />

      <Profiler id='UserCustomAudiosTab' onRender={onRenderCallback}>
        <UserCustomAudiosTab userId={id} />
      </Profiler>
    </Profiler>
  );
});

AdminUserAudios.displayName = 'AdminUserAudios';

export default AdminUserAudios;
